import { Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Modal, Row, Select, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import { OptionProps } from 'antd/lib/select';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { FormatDate } from '../../components/table/Date';
import { RedeemCodeTemplate } from '../../types/redeemCode';
import { CreateRedeemCode } from './CreateRedeemCode';
import { WrappedCreateRedeemCodeTemplateForm } from './CreateRedeemCodeTemplateForm';

const CreateRedeemCodeForm: any = Form.create()(CreateRedeemCode);
const { Option } = Select;

export const REDEEM_CODE_TEMPLATES_QUERY = gql`
  query FindTemplates($channel: String, $id: ID, $desc: String) {
    redeemCodeTemplates(channel: $channel, id: $id, desc: $desc) {
      id
      channel
      skuGroupId
      skuId
      desc
      duration
      createdAt
      price
      activityPrice
      cost
      marketingCost
    }
  }
`;

export const TipContent = styled.div`
  color: #00000066;
  line-height: 2.5;
  font-size: 10px;
  padding-left: 5px;
`;

export const skuGroupListQuery = gql`
  query {
    skuGroups {
      id
      name
      description
    }
  }
`;

const skusQuery = gql`
  query {
    skus {
      id
      name
    }
  }
`;
const createRedeemCodeTemplateMutation = gql`
  mutation createRedeemCodeTemplate(
    $channel: String!
    $skuGroupId: Int
    $duration: Int!
    $desc: String!
    $skuId: Int
    $price: Float!
    $activityPrice: Float!
    $cost: Float!
    $marketingCost: Float!
  ) {
    createRedeemCodeTemplate(
      channel: $channel
      skuGroupId: $skuGroupId
      duration: $duration
      desc: $desc
      skuId: $skuId
      price: $price
      activityPrice: $activityPrice
      cost: $cost
      marketingCost: $marketingCost
    ) {
      id
      channel
      skuGroupId
      duration
      desc
      price
      activityPrice
      cost
      marketingCost
    }
  }
`;
interface Props {
  match: any;
  form: WrappedFormUtils;
}

interface State {
  variables: {
    id?: string;
    channel?: string;
    desc?: string;
  };
  isCreateRedeemCodeTemplateConfirmVisible: boolean;
  skuGroupId?: number;
  skuId?: number;
  channel: string;
  desc: string;
  duration?: number;
  price?: number;
  activityPrice?: number;
  cost?: number;
  marketingCost?: number;
}

class RedeemCodeTemplateList extends Component<Props, State> {
  private createRedeemCodeTemplateForm: any;
  constructor(props: Props) {
    super(props);

    this.state = {
      variables: {},
      isCreateRedeemCodeTemplateConfirmVisible: false,
      channel: '',
      desc: '',
    };

    this.onDescChange = this.onDescChange.bind(this);
    this.onDurationChange = this.onDurationChange.bind(this);
    this.onSkuGroupIdChange = this.onSkuGroupIdChange.bind(this);
    this.hideCreateRedeemCodeTemplateModal = this.hideCreateRedeemCodeTemplateModal.bind(this);
    this.showCreateRedeemCodeTemplateModal = this.showCreateRedeemCodeTemplateModal.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }

  componentDidMount() {
    this.props.form.validateFields();
  }

  showCreateRedeemCodeTemplateModal() {
    this.setState({
      isCreateRedeemCodeTemplateConfirmVisible: true,
    });
  }

  hideCreateRedeemCodeTemplateModal() {
    this.setState({ isCreateRedeemCodeTemplateConfirmVisible: false });
  }

  onSkuGroupIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      skuGroupId: Number(e.target.value),
    });
  };
  onDescChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      desc: e.target.value,
    });
  };
  onDurationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const duration = Number(e.target.value) * 24 * 60 * 60;
    this.setState({
      duration,
    });
  };

  onPriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      price: Number(e.target.value),
    });
  };
  onActivityPriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      activityPrice: Number(e.target.value),
    });
  };
  onCostChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      cost: Number(e.target.value),
    });
  };
  onMarketingCostChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      marketingCost: Number(e.target.value),
    });
  };

  search = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      this.setState({
        variables: {
          id: values.redeemCodeTemplateId,
          channel: values.redeemCodeTemplateChannel,
          desc: values.redeemCodeTemplateDesc,
        },
      });
    });
  };

  onResetClick() {
    this.props.form.resetFields();
  }

  getSkusList = () => {
    return (
      <Query query={skusQuery} variables={{}}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const skus = (data && data.skus) || [];
          return (
            <Select
              placeholder="请选择sku"
              showSearch
              optionFilterProp="children"
              filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
                return String(option.props.children).indexOf(input) >= 0;
              }}
              style={{ width: '100%' }}
              onChange={(value: number) => {
                this.setState({ skuId: value });
              }}
            >
              {skus.map((sku: { id: number; name: string }) => (
                <Option value={sku.id} key={sku.id}>
                  {sku.name}
                </Option>
              ))}
            </Select>
          );
        }}
      </Query>
    );
  };

  popupOfferCreateRedeemCode() {
    const { skuGroupId, duration, channel, desc, skuId, price, activityPrice, cost, marketingCost } = this.state;
    return (
      <Mutation
        mutation={createRedeemCodeTemplateMutation}
        variables={{
          skuGroupId,
          duration,
          desc,
          skuId,
          price,
          activityPrice,
          cost,
          marketingCost,
          channel,
        }}
        refetchQueries={[
          {
            query: REDEEM_CODE_TEMPLATES_QUERY,
            variables: this.state.variables,
          },
        ]}
      >
        {createRedeemCodeTemplate => {
          return (
            <Modal
              width="60%"
              title="确认生成兑换码模版"
              visible={this.state.isCreateRedeemCodeTemplateConfirmVisible}
              onOk={async () => {
                try {
                  const createRedeemCodeTemplateForm = this.createRedeemCodeTemplateForm;
                  if (!createRedeemCodeTemplateForm) {
                    return;
                  }
                  createRedeemCodeTemplateForm.validateFields(async (err, values) => {
                    if (err) {
                      message.error(err);
                      return;
                    }
                    if (!values.skuId && !values.skuGroupId) {
                      message.error('skuId,skuGroupId至少选择一个');
                      return;
                    }

                    if (values.price === undefined || isNaN(values.price)) {
                      message.error('市场价为必填项');
                      return;
                    }
                    if (values.activityPrice === undefined || isNaN(values.activityPrice)) {
                      message.error('活动价为必填项');
                      return;
                    }
                    if (values.cost === undefined || isNaN(values.cost)) {
                      message.error('课程成本为必填项');
                      return;
                    }
                    if (values.marketingCost === undefined || isNaN(values.marketingCost)) {
                      message.error('市场课程成本为必填项');
                      return;
                    }
                    this.setState(
                      {
                        channel: values.channel,
                        desc: values.desc,
                        skuId: values.skuId,
                        skuGroupId: values.skuGroupId,
                        price: values.price,
                        duration: Number(values.duration) * 24 * 60 * 60,
                        activityPrice: values.activityPrice,
                        cost: values.cost,
                        marketingCost: values.marketingCost,
                        isCreateRedeemCodeTemplateConfirmVisible: false,
                      },
                      async () => {
                        await createRedeemCodeTemplate();
                        message.success('生成成功');
                      },
                    );
                  });
                } catch (e) {
                  message.error('生成失败');
                }
              }}
              onCancel={this.hideCreateRedeemCodeTemplateModal}
            >
              <WrappedCreateRedeemCodeTemplateForm
                ref={node => {
                  this.createRedeemCodeTemplateForm = node;
                }}
              />
            </Modal>
          );
        }}
      </Mutation>
    );
  }
  render() {
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>兑换码模版</Breadcrumb.Item>
        </Breadcrumb>
        <Query query={REDEEM_CODE_TEMPLATES_QUERY} variables={this.state.variables}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const redeemCodeTemplates = data.redeemCodeTemplates;
            const { getFieldDecorator } = this.props.form;
            return (
              <Card>
                <Form onSubmit={this.search}>
                  <Row gutter={24}>
                    <Col xs={24} md={24} lg={8} xl={8} xxl={8} style={{ marginTop: 10 }}>
                      <FormItem label={`ID`}>
                        {getFieldDecorator('redeemCodeTemplateId')(<Input allowClear placeholder="请输入模版ID" />)}
                      </FormItem>
                    </Col>
                    <Col xs={24} md={24} lg={8} xl={8} xxl={8} style={{ marginTop: 10 }}>
                      <FormItem label={`渠道`}>
                        {getFieldDecorator('redeemCodeTemplateChannel')(<Input allowClear />)}
                      </FormItem>
                    </Col>
                    <Col xs={24} md={24} lg={8} xl={8} xxl={8} style={{ marginTop: 10 }}>
                      <FormItem label={`渠道描述`}>
                        {getFieldDecorator('redeemCodeTemplateDesc')(<Input allowClear placeholder="请输入渠道描述" />)}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row type="flex" justify="end">
                    <Button icon="search" style={{ marginRight: 8 }} type="primary" htmlType="submit">
                      搜索
                    </Button>
                    <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                      重置
                    </Button>
                    <Button
                      style={{ marginLeft: 8 }}
                      type="primary"
                      icon="plus"
                      onClick={this.showCreateRedeemCodeTemplateModal}
                    >
                      生成模版
                    </Button>
                    {this.popupOfferCreateRedeemCode()}
                  </Row>
                </Form>
                <Table<RedeemCodeTemplate>
                  dataSource={redeemCodeTemplates}
                  loading={loading}
                  pagination={false}
                  rowKey={row => `${row.id}`}
                >
                  <Table.Column dataIndex="id" title="模版ID" key="id" />
                  <Table.Column dataIndex="channel" title="渠道" key="channel" />
                  <Table.Column dataIndex="skuGroupId" title="skuGroupId" key="skuGroupId" />
                  <Table.Column dataIndex="skuId" title="skuId" key="skuId" />
                  <Table.Column dataIndex="desc" title="描述" key="desc" />
                  <Table.Column key="price" title="市场价" render={record => record.price || '-'} />
                  <Table.Column key="activityPrice" title="活动价" render={record => record.activityPrice || '-'} />
                  <Table.Column key="cost" title="课程成本" render={record => record.cost || '-'} />
                  <Table.Column
                    key="marketingCost"
                    title="市场课程成本"
                    render={record => record.marketingCost || '-'}
                  />
                  <Table.Column
                    dataIndex="createdAt"
                    key="createdAt"
                    title="生成日期"
                    render={createdAt => <FormatDate mode="datetime" date={createdAt} />}
                  />
                  <Table.Column
                    dataIndex="duration"
                    key="duration"
                    title="有效期"
                    render={duration => `生成${moment.duration(duration, 'seconds').humanize()}内有效`}
                  />
                  <Table.Column
                    key="actions"
                    title="操作"
                    render={row => (
                      <>
                        <CreateRedeemCodeForm redeemCodeTemplate={row} />
                        <Link to={`/redeem-code-template/list/${row.id}/codes`} style={{ marginLeft: 5 }}>
                          查看兑换码
                        </Link>
                      </>
                    )}
                  />
                </Table>
              </Card>
            );
          }}
        </Query>
      </>
    );
  }
}

export const RedeemCodeTemplateListForm = Form.create({ name: 'RedeemCodeTemplateListForm' })(RedeemCodeTemplateList);



// WEBPACK FOOTER //
// ./src/screens/redeemCode/RedeemCodeTemplateList.tsx